
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_wih1l_1pl79_13",
  "tools": "awsui_tools_wih1l_1pl79_24",
  "tools-filtering": "awsui_tools-filtering_wih1l_1pl79_33",
  "tools-align-right": "awsui_tools-align-right_wih1l_1pl79_46",
  "tools-clear-sort": "awsui_tools-clear-sort_wih1l_1pl79_50",
  "tools-pagination": "awsui_tools-pagination_wih1l_1pl79_53",
  "tools-preferences": "awsui_tools-preferences_wih1l_1pl79_53",
  "tools-small": "awsui_tools-small_wih1l_1pl79_59",
  "table": "awsui_table_wih1l_1pl79_63",
  "table-layout-fixed": "awsui_table-layout-fixed_wih1l_1pl79_70",
  "wrapper": "awsui_wrapper_wih1l_1pl79_74",
  "variant-stacked": "awsui_variant-stacked_wih1l_1pl79_81",
  "wrapper-content-measure": "awsui_wrapper-content-measure_wih1l_1pl79_81",
  "variant-container": "awsui_variant-container_wih1l_1pl79_81",
  "has-footer": "awsui_has-footer_wih1l_1pl79_84",
  "has-header": "awsui_has-header_wih1l_1pl79_87",
  "cell-merged": "awsui_cell-merged_wih1l_1pl79_104",
  "cell-merged-content": "awsui_cell-merged-content_wih1l_1pl79_116",
  "empty": "awsui_empty_wih1l_1pl79_132",
  "loading": "awsui_loading_wih1l_1pl79_136",
  "selection-control": "awsui_selection-control_wih1l_1pl79_145",
  "selection-control-header": "awsui_selection-control-header_wih1l_1pl79_152",
  "selection-control-content-spans-rows": "awsui_selection-control-content-spans-rows_wih1l_1pl79_157",
  "header-secondary": "awsui_header-secondary_wih1l_1pl79_164",
  "variant-full-page": "awsui_variant-full-page_wih1l_1pl79_175",
  "table-has-header": "awsui_table-has-header_wih1l_1pl79_181",
  "header-controls": "awsui_header-controls_wih1l_1pl79_192",
  "variant-embedded": "awsui_variant-embedded_wih1l_1pl79_204",
  "variant-borderless": "awsui_variant-borderless_wih1l_1pl79_204",
  "footer-wrapper": "awsui_footer-wrapper_wih1l_1pl79_209",
  "footer": "awsui_footer_wih1l_1pl79_209",
  "footer-with-pagination": "awsui_footer-with-pagination_wih1l_1pl79_217",
  "footer-pagination": "awsui_footer-pagination_wih1l_1pl79_225",
  "thead-active": "awsui_thead-active_wih1l_1pl79_229",
  "row": "awsui_row_wih1l_1pl79_230",
  "row-selected": "awsui_row-selected_wih1l_1pl79_231",
  "skeleton-loading-cell": "awsui_skeleton-loading-cell_wih1l_1pl79_235"
};
  